const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Agenda de Citas y Reservas Online",
    summary:
      "Sistema centralizado para administrar citas y turnos de atención. Permite visualizar el calendario por día, semana o mes, gestionar estados (pendiente, confirmada, cancelada), configurar enlaces públicos de reserva y coordinar la atención entre profesionales y clientes.",
  },
  sections: [
    {
      id: "calendario_citas",
      title: "1. Vistas de Calendario y Horarios",
      description:
        "Control visual de la disponibilidad y carga de trabajo.",
      items: [
        {
          id: "vistas_temporales",
          title: "Vistas por Mes, Semana y Día",
          definition:
            "Alterna entre distintas perspectivas para planificar citas a largo plazo o monitorear el flujo de pacientes/clientes en tiempo real durante la jornada.",
        },
        {
          id: "estados_cita",
          title: "Código de Estados de Atención",
          definition:
            "Clasifica cada cita por color y estado: Pendiente (amarillo), Confirmada (verde), Cancelada (rojo) o En Atención (azul).",
        },
      ],
    },
    {
      id: "enlace_publico",
      title: "2. Enlace Público de Auto-Reserva",
      description:
        "Facilidad para que los clientes elijan su turno desde WhatsApp o web.",
      items: [
        {
          id: "link_reserva",
          title: "URL Pública para Clientes",
          definition:
            "Genera y comparte un enlace web donde el cliente visualiza directamente los servicios, el especialista de su preferencia y los horarios libres para autogestionar su cita.",
        },
        {
          id: "confirmacion_inmediata",
          title: "Confirmación en Tiempo Real",
          definition:
            "Al agendarse una cita pública, se bloquea el espacio en la agenda y se registra automáticamente el contacto en BotMix CRM.",
        },
      ],
    },
    {
      id: "gestion_citas",
      title: "3. Creación y Edición Manual de Citas",
      description:
        "Herramientas para operadores y recepcionistas.",
      items: [
        {
          id: "registro_rapido",
          title: "Nueva Cita Directa",
          definition:
            "Haz clic en cualquier celda horaria del calendario para crear una cita seleccionando el cliente, el servicio requerido, el profesional a cargo y la fecha/hora estimada.",
        },
        {
          id: "reprogramacion",
          title: "Reprogramación y Cancelación",
          definition:
            "Mueve citas arrastrando en el calendario o editando la ficha para ajustar el horario sin perder el historial del cliente.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Appointment Scheduling & Online Bookings",
    summary:
      "Centralized appointment and booking calendar. Manage views across month, week, or day, update appointment statuses (pending, confirmed, canceled), share self-service public booking links, and orchestrate service sessions between staff and customers.",
  },
  sections: [
    {
      id: "calendario_citas",
      title: "1. Calendar Views & Schedules",
      description:
        "Visual control of team capacity and appointment flow.",
      items: [
        {
          id: "vistas_temporales",
          title: "Month, Week & Day Views",
          definition:
            "Switch between calendar views to plan long-term appointments or coordinate real-time patient/client arrivals throughout the day.",
        },
        {
          id: "estados_cita",
          title: "Appointment Status Color Coding",
          definition:
            "Categorize sessions by color and status: Pending (yellow), Confirmed (green), Canceled (red), or In Progress (blue).",
        },
      ],
    },
    {
      id: "enlace_publico",
      title: "2. Public Self-Booking Link",
      description:
        "Empower clients to book their own appointments via WhatsApp or the web.",
      items: [
        {
          id: "link_reserva",
          title: "Public Customer Booking URL",
          definition:
            "Share an interactive web portal where clients view service catalogs, pick their preferred professional, and select open timeslots directly.",
        },
        {
          id: "confirmacion_inmediata",
          title: "Real-Time Slot Reservation",
          definition:
            "When booked online, the slot locks immediately and creates or matches the customer profile in BotMix CRM.",
        },
      ],
    },
    {
      id: "gestion_citas",
      title: "3. Manual Booking & Adjustments",
      description:
        "Front-desk tools for fast appointment entry.",
      items: [
        {
          id: "registro_rapido",
          title: "Direct Slot Booking",
          definition:
            "Click any calendar timeslot to register an appointment, link a customer, choose the service, assign the professional, and define notes.",
        },
        {
          id: "reprogramacion",
          title: "Rescheduling & Cancellations",
          definition:
            "Drag and drop sessions or edit appointment modals to adjust times without losing client history.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Agenda de Atendimentos e Agendamento Online",
    summary:
      "Sistema centralizado para gestão de agendamentos e consultas. Permite acompanhar o calendário por mês, semana ou dia, gerenciar status (pendente, confirmado, cancelado), compartilhar links públicos de autoagendamento e coordenar o fluxo entre profissionais e clientes.",
  },
  sections: [
    {
      id: "calendario_citas",
      title: "1. Visualizações do Calendário e Horários",
      description:
        "Controle visual da disponibilidade e capacidade de atendimento.",
      items: [
        {
          id: "vistas_temporales",
          title: "Visualizações por Mês, Semana e Dia",
          definition:
            "Alterne entre perspectivas para planejar atendimentos futuros ou monitorar o fluxo diário de clientes em tempo real.",
        },
        {
          id: "estados_cita",
          title: "Status de Atendimento com Código de Cores",
          definition:
            "Identifique rapidamente cada consulta: Pendente (amarelo), Confirmada (verde), Cancelada (vermelho) ou Em Atendimento (azul).",
        },
      ],
    },
    {
      id: "enlace_publico",
      title: "2. Link Público de Autoagendamento",
      description:
        "Permita que os clientes escolham o melhor horário pelo WhatsApp ou navegador.",
      items: [
        {
          id: "link_reserva",
          title: "URL Pública para Clientes",
          definition:
            "Gera uma página de autoatendimento onde o cliente escolhe o serviço, o especialista desejado e os horários livres na agenda.",
        },
        {
          id: "confirmacion_inmediata",
          title: "Confirmação em Tempo Real",
          definition:
            "Ao concluir o agendamento, o horário é bloqueado na agenda e o contato é sincronizado com o BotMix CRM.",
        },
      ],
    },
    {
      id: "gestion_citas",
      title: "3. Gestão e Criação Manual de Consultas",
      description:
        "Recursos práticos para recepcionistas e operadores.",
      items: [
        {
          id: "registro_rapido",
          title: "Novo Agendamento Rápido",
          definition:
            "Clique diretamente no horário desejado no calendário para cadastrar a consulta, vinculando cliente, serviço e profissional.",
        },
        {
          id: "reprogramacion",
          title: "Remarcação e Cancelamento",
          definition:
            "Arraste e solte atendimentos na grade ou edite o formulário para reagendar sem perder o histórico do cliente.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Planning des Rendez-vous et Réservation en Ligne",
    summary:
      "Plateforme centralisée de gestion des rendez-vous et plannings d'accueil. Consultez l'agenda par mois, semaine ou jour, suivez les statuts (en attente, confirmé, annulé), partagez des liens publics d'auto-réservation et coordonnez les créneaux entre praticiens et clients.",
  },
  sections: [
    {
      id: "calendario_citas",
      title: "1. Vues d'Agenda et Horaires",
      description:
        "Gestion visuelle de la charge de travail et des disponibilités.",
      items: [
        {
          id: "vistas_temporales",
          title: "Vues par Mois, Semaine et Jour",
          definition:
            "Passez d'une vue à l'autre pour organiser vos créneaux futurs ou suivre le déroulement des séances de la journée.",
        },
        {
          id: "estados_cita",
          title: "Statuts des Rendez-vous avec Codes Couleur",
          definition:
            "Suivez chaque créneau : En attente (jaune), Confirmé (vert), Annulé (rouge) ou En cours (bleu).",
        },
      ],
    },
    {
      id: "enlace_publico",
      title: "2. Lien Public d'Auto-Réservation",
      description:
        "Offrez à vos clients la liberté de réserver leur créneau en toute autonomie.",
      items: [
        {
          id: "link_reserva",
          title: "Lien de Réservation Dédié",
          definition:
            "Diffusez une page web où le client choisit la prestation, l'intervenant de son choix et son créneau libre.",
        },
        {
          id: "confirmacion_inmediata",
          title: "Blocage et Validation Instantanés",
          definition:
            "La réservation bloque immédiatement le créneau dans l'agenda et rattache le client dans le CRM BotMix.",
        },
      ],
    },
    {
      id: "gestion_citas",
      title: "3. Prise de Rendez-vous et Ajustements Manuels",
      description:
        "Outils adaptés pour le secrétariat et les agents d'accueil.",
      items: [
        {
          id: "registro_rapido",
          title: "Création Directe sur l'Agenda",
          definition:
            "Cliquez sur la plage horaire souhaitée pour enregistrer un rendez-vous avec le client, la prestation et le praticien assigné.",
        },
        {
          id: "reprogramacion",
          title: "Report et Annulation",
          definition:
            "Déplacez les rendez-vous par glisser-déposer pour ajuster les horaires sans perdre l'historique.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "جدول المواعيد والحجوزات عبر الإنترنت",
    summary:
      "نظام مركزي لإدارة المواعيد وجداول العمل. يتيح عرض التقويم شهرياً وأسبوعياً ويومياً، وتتبع حالات المواعيد (معلق، مؤكد، ملغي)، ومشاركة روابط الحجز الذاتي المباشرة وتنسيق الجداول بين الأخصائيين والعملاء.",
  },
  sections: [
    {
      id: "calendario_citas",
      title: "1. عروض التقويم وتوزيع الأوقات",
      description:
        "تحكم بصري شامل في القدرة الاستيعابية وسير العمل.",
      items: [
        {
          id: "vistas_temporales",
          title: "عروض حسب الشهر والأسبوع واليوم",
          definition:
            "التنقل بين وجهات النظر المختلفة للتخطيط للمواعيد بعيدة المدى أو مراقبة توافد العملاء خلال اليوم بدقة.",
        },
        {
          id: "estados_cita",
          title: "الترميز اللوني لحالات المواعيد",
          definition:
            "تصنيف المواعيد بالألوان والحالات: قيد الانتظار (أصفر)، مؤكد (أخضر)، ملغي (أحمر) أو قيد التنفيذ (أزرق).",
        },
      ],
    },
    {
      id: "enlace_publico",
      title: "2. رابط الحجز الذاتي العام",
      description:
        "تمكين العملاء من حجز مواعيدهم بأنفسهم عبر واتساب أو الويب.",
      items: [
        {
          id: "link_reserva",
          title: "رابط الحجز المباشر للعملاء",
          definition:
            "رابط تفاعلي يتيح للعميل استعراض قائمة الخدمات، واختيار الأخصائي المفضل، وتحديد الموعد المتاح تلقائياً.",
        },
        {
          id: "confirmacion_inmediata",
          title: "تأكيد فوري وتحديث التقويم",
          definition:
            "عند إتمام الحجز، يتم حجز الفترة الزمنية فوراً في الجدول ومزامنة بيانات العميل في BotMix CRM.",
        },
      ],
    },
    {
      id: "gestion_citas",
      title: "3. الإدخال والتعديل اليدوي للمواعيد",
      description:
        "أدوات عملية لموظفي الاستقبال وخدمة العملاء.",
      items: [
        {
          id: "registro_rapido",
          title: "تسجيل موعد مباشر في الجدول",
          definition:
            "انقر فوق أي خانة زمنية شاغرة في التقويم لإنشاء موعد وتعيين العميل والخدمة والأخصائي المسؤول.",
        },
        {
          id: "reprogramacion",
          title: "إعادة الجدولة والإلغاء",
          definition:
            "إعادة ترتيب المواعيد بسهولة بالسحب والإفلات أو تعديل النموذج دون فقدان سجل العميل وتفاصيله.",
        },
      ],
    },
  ],
};

export const APPOINTMENTS_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
